import { render, staticRenderFns } from "./zhiwei.vue?vue&type=template&id=24cf9685&scoped=true"
import script from "./zhiwei.vue?vue&type=script&lang=js"
export * from "./zhiwei.vue?vue&type=script&lang=js"
import style0 from "./zhiwei.vue?vue&type=style&index=0&id=24cf9685&prod&lang=scss"
import style1 from "./zhiwei.vue?vue&type=style&index=1&id=24cf9685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf9685",
  null
  
)

export default component.exports